export default {
    methods:{
        goToBack(){
            this.router.go(-1);
        }
    }
}